import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

export interface ClientMetadata {
  departments: string[];
  occupations: string[];
}

@Injectable({ providedIn: 'root' })
export class ClientMetadataService {
  private http = inject(HttpClient);
  private api = environment.apiUrl;

  /** Cache por campaignId para no repetir llamadas */
  private cache = new Map<string, Observable<ClientMetadata>>();

  getClientMetadata(campaignId: string): Observable<ClientMetadata> {
    if (!campaignId) return of({ departments: [], occupations: [] });

    const cached = this.cache.get(campaignId);
    if (cached) return cached;

    const req$ = this.http
      .get<ClientMetadata>(`${this.api}/campaigns/${campaignId}/client-metadata`)
      .pipe(
        map((raw) => {
          // Normalizamos a { departments, occupations }
          const departments =
            raw.departments ??
            [];
          const occupations =
            raw.occupations ??
            [];
          return { departments, occupations };
        }),
        catchError((err: HttpErrorResponse) => {
          const msg =
            (err?.error && (err.error.message || err.error.error)) ||
            err.message ||
            'Error obteniendo metadatos del cliente.';
          return throwError(() => new Error(msg));
        }),
        // Memoizamos el resultado
        shareReplay(1)
      );

    this.cache.set(campaignId, req$);
    return req$;
  }
}
